import { i18n } from 'src/i18n';

export const formatCurrency = (value: number): string => {
  const formattedNumber: string = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return `${formattedNumber} ${i18n.currency.suffix}`;
};

export const formatCurrencyWithMonthlySuffix = (value: number): string =>
  `${formatCurrency(value)} ${i18n.currency.monthlyPriceSuffix}`;
